import { render, staticRenderFns } from "./ValueChainForm.vue?vue&type=template&id=d074fc10"
import script from "./ValueChainForm.vue?vue&type=script&lang=js"
export * from "./ValueChainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports